module.exports = __webpack_public_path__ + "static/media/21ECLAC40.66e79b3d.jpg";